import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

export const useOnRouteScrollTo = (x: number, y: number): React.MutableRefObject<HTMLDivElement | undefined> => {
  const { pathname } = useLocation();
  const ref = useRef<HTMLDivElement>();

  useEffect(() => {
    ref?.current?.scrollTo(x, y);
  }, [pathname, x, y]);

  return ref;
};
